import sideBarDefaultLogoDarkMode from "@assets/images/citi-logo-dark-mode.png";
import sideBarDefaultLogo from "@assets/images/citi-logo-light-mode.png";
import { useLegacyThemeHandler } from "@dashboard/components/Sidebar/user/Controls";
import { Avatar, Box, Text } from "@saleor/macaw-ui/next";
import React from "react";

export const MountingPoint = () => {
  const { theme } = useLegacyThemeHandler();
  const logo =
    theme === "defaultLight" ? sideBarDefaultLogo : sideBarDefaultLogoDarkMode;

  return (
    <Box display="flex" gap={2} paddingX={4} paddingY={5} alignItems="center">
      <Avatar.Store
        src={logo}
        backgroundColor={"transparent"}
        objectFit={"contain"}
      />
      <Text variant="bodyStrong" size="small">
        CitiHardware Dashboard
      </Text>
    </Box>
  );
};
